import { useState } from "react";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import CTLNotification from "application/components/CTLNotification";
import variables from "globals/variables";
import axios from "axios";
function VoicePickerFileDownload({ row }) {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const filename = row.original.ccRecordFilename;
  let str = filename;
  let index = str.lastIndexOf("/");
  let extracted = str.slice(index + 1, str.length)

  const operationURLSS = {
    fileDownload: `${variables.app.services}auth/downloadMp3?path=${encodeURIComponent(filename)}`,
  }

  // Download Voice Picker MP3 File
function onDownloadFile() {
  axios
    .get(operationURLSS.fileDownload, {
      responseType: 'blob',
      headers: {
        // Add auth header if required
        // Authorization: 'Bearer ' + token,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // 🔹 Extract filename from Content-Disposition header
        let filename = 'download.wav';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.includes('filename')) {
          const matches = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches != null && matches[1]) {
            filename = decodeURIComponent(matches[1].replace(/['"]/g, ''));
          }
        }

        // 🔹 Create blob and trigger browser download
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        setNotify({
          isOpen: true,
          message: `MP3 File Download Successful: ${filename}`,
          type: 'success',
        });
      } else {
        throw new Error(`Request failed with status: ${response.status}`);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      setNotify({
        isOpen: true,
        message: 'Unable To Download MP3 File',
        type: 'error',
        pagename: 'voice picker',
        status: error.response ? error.response.status : null,
      });
    });
}

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <Tooltip title="DownloadFile">
        <IconButton color="error" onClick={() => onDownloadFile()}>
          <DownloadingIcon></DownloadingIcon>
        </IconButton>
      </Tooltip>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDTypography>
  );
}

export default VoicePickerFileDownload;



